"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateRenderableInput = void 0;
const react_1 = require("react");
function useValidateRenderableInput(id, validation) {
    return (0, react_1.useCallback)((value) => __awaiter(this, void 0, void 0, function* () {
        if (!validation) {
            return null;
        }
        try {
            yield validation.validate(value);
            return null;
        }
        catch (e) {
            return e.errors[0];
        }
    }), [validation, id]);
}
exports.useValidateRenderableInput = useValidateRenderableInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVuZGVyYWJsZUlucHV0VXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zYW5kYm94L2lucHV0cy9yZW5kZXJhYmxlSW5wdXRVdGlscy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsaUNBQW9DO0FBR3BDLFNBQWdCLDBCQUEwQixDQUN4QyxFQUFVLEVBQ1YsVUFBdUI7SUFFdkIsT0FBTyxJQUFBLG1CQUFXLEVBQ2hCLENBQU0sS0FBSyxFQUFDLEVBQUU7UUFDWixJQUFJLENBQUMsVUFBVSxFQUFFO1lBQ2YsT0FBTyxJQUFJLENBQUM7U0FDYjtRQUNELElBQUk7WUFDRixNQUFNLFVBQVUsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDakMsT0FBTyxJQUFJLENBQUM7U0FDYjtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1YsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO1NBQ3BCO0lBQ0gsQ0FBQyxDQUFBLEVBQ0QsQ0FBQyxVQUFVLEVBQUUsRUFBRSxDQUFDLENBQ2pCLENBQUM7QUFDSixDQUFDO0FBbEJELGdFQWtCQyJ9